/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_appsync_graphqlEndpoint": "https://52hn6qbvhnat7ngysxmvrro56q.appsync-api.us-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-west-1:b1a0c5d8-0eaf-4a7f-b731-720e7d95ffe1",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_DJq8TifES",
    "aws_user_pools_web_client_id": "36suv52h61jf6qqtqar4bjeg5m",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "stmatocs1eefe848d26f941069f0c667a63fa221160824-dev",
    "aws_user_files_s3_bucket_region": "us-west-1"
};


export default awsmobile;
